module.exports = __webpack_public_path__ + "img/landing-macbook-oncloud.how@2x.7d80715b.png";